import Component from '@glimmer/component'
import { action } from '@ember/object'
import config from 'teacher-ui-client/config/environment'
import { eventValue } from 'teacher-ui-client/helpers/event-value'
import { on } from '@ember/modifier'
import { eq } from 'ember-truth-helpers'

interface Signature {
  Element: HTMLDivElement
}

export class MirageScenario extends Component<Signature> {
  get showScenarioSelect() {
    return config.environment === 'development'
  }

  get selectedScenario() {
    return window.localStorage.getItem('teacher-ui-client.mirage-scenario')
  }

  get availableScenarios() {
    return window.localStorage.getItem('teacher-ui-client.mirage-scenarios-all')?.split(',') ?? []
  }

  @action
  setScenario(scenarioId: string) {
    window.localStorage.setItem('teacher-ui-client.mirage-scenario', scenarioId)
    window.location.replace('/')
  }

  <template>
    {{! template-lint-disable no-bare-strings }}
    {{#if this.showScenarioSelect}}
      <div ...attributes>
        Mirage:
        {{! template-lint-disable require-input-label }}
        <select {{on "input" (eventValue this.setScenario)}}>
          {{#each this.availableScenarios as |scenario|}}
            <option value={{scenario}} selected={{eq this.selectedScenario scenario}}>{{scenario}}</option>
          {{/each}}
        </select>
      </div>
    {{/if}}
  </template>
}

export default MirageScenario
